/** 签名用时间戳：直接使用本地时间（毫秒） */
export function getServerTimestamp() {
  return Date.now();
}
